<div class="flex flex-col h-full">

  <!-- Header -->
  <div class="flex flex-row items-center justify-between px-6 py-4 border-b border-grey-200">
    <span class="text-xl font-semibold text-grey-900">Dealer Recommendations</span>
    <button mat-raised-button color="primary" class="rounded" (click)="addRecommendation()" [disabled]="isLoading || loadError || saving">
      <mat-icon style="font-size: 18px; height: 18px; width: 18px;">add</mat-icon>
      <span class="ml-1">Add Recommendation</span>
    </button>
  </div>

  <!-- Loading state -->
  <div *ngIf="isLoading" class="flex-1 flex items-center justify-center">
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <!-- Error state -->
  <div *ngIf="loadError" class="flex-1 flex items-center justify-center">
    <span class="text-sm text-grey-500">Failed to load dealer recommendations. Please try again.</span>
  </div>

  <!-- Empty state -->
  <div *ngIf="!isLoading && !loadError && recommendations.length === 0" class="flex-1 flex items-center justify-center">
    <span class="text-sm text-grey-500">No dealer recommendations yet. Click '+ Add Recommendation' to create one.</span>
  </div>

  <!-- List -->
  <div *ngIf="!isLoading && !loadError && recommendations.length > 0" class="flex-1 overflow-y-auto">

    <!-- Sticky column headers -->
    <div class="flex flex-row items-center px-6 py-3 border-b border-grey-200 bg-white sticky top-0 z-20">
      <span class="w-2/5 min-w-0 pr-4 text-xs font-semibold text-grey-900 uppercase tracking-wide">DMS Service Group</span>
      <span class="w-1/5 min-w-0 pr-4 text-xs font-semibold text-grey-900 uppercase tracking-wide">Mileage Interval</span>
      <span class="w-1/5 min-w-0 pr-4 text-xs font-semibold text-grey-900 uppercase tracking-wide">Time Interval</span>
      <span class="flex-1"></span>
    </div>

    <!-- Rows -->
    <div *ngFor="let rec of recommendations; trackBy: trackById"
      class="flex flex-row items-center px-6 py-3 border-b border-grey-100 hover:bg-grey-50">

      <!-- Service group cell -->
      <span class="w-2/5 min-w-0 pr-4 flex items-center gap-2">
        <span *ngIf="isServiceGroupKnown(rec); else unknownGroup" class="flex items-center gap-2 min-w-0">
          <span class="op-code-chip shrink-0">{{ getServiceGroupOpCode(rec) || '—' }}</span>
          <span class="text-sm text-grey-700 truncate">{{ getServiceGroupName(rec) }}</span>
        </span>
        <ng-template #unknownGroup>
          <span class="text-sm text-grey-400 italic">Unknown service group</span>
        </ng-template>
      </span>

      <!-- Mileage cell -->
      <span class="w-1/5 min-w-0 pr-4 text-sm text-grey-700">
        <ng-container *ngIf="rec.intervalMileage; else noMileage">
          Every {{ rec.intervalMileage | number | unitOfMeasure | async }}
        </ng-container>
        <ng-template #noMileage>
          <span class="text-grey-400">—</span>
        </ng-template>
      </span>

      <!-- Time cell -->
      <span class="w-1/5 min-w-0 pr-4 text-sm text-grey-700">
        <ng-container *ngIf="rec.intervalMonths; else noMonths">
          Every {{ rec.intervalMonths }} {{ rec.intervalMonths === 1 ? 'month' : 'months' }}
        </ng-container>
        <ng-template #noMonths>
          <span class="text-grey-400">—</span>
        </ng-template>
      </span>

      <!-- Actions -->
      <div class="flex-1 flex justify-end items-center gap-1">
        <button mat-icon-button (click)="editRecommendation(rec)" [disabled]="!isServiceGroupKnown(rec) || saving"
          aria-label="Edit recommendation">
          <mat-icon style="font-size: 18px; height: 18px; width: 18px; color: #0054a6;">edit</mat-icon>
        </button>
        <button mat-icon-button (click)="deleteRecommendation(rec)" [disabled]="saving"
          aria-label="Delete recommendation">
          <mat-icon style="font-size: 18px; height: 18px; width: 18px; color: #757575;">delete_outline</mat-icon>
        </button>
      </div>
    </div>
  </div>

</div>
